import {
  DocumentData,
  DocumentSnapshot,
  FirestoreDataConverter,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";
import { FeatureFlag } from "../featureFlags/featureFlags";

export const featureFlagConverter: FirestoreDataConverter<FeatureFlag> = {
  toFirestore(flag: WithFieldValue<FeatureFlag>): DocumentData {
    const { id: _id, ...data } = flag as FeatureFlag;
    return {
      enabled: data.enabled === true,
    };
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): FeatureFlag {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      enabled: data?.enabled === true,
    };
  },
};
